export default __webpack_public_path__ + "static/img/22.b7bbfe0.png";